<template>
  <div>

    <toggle-header
      :id="'armor-details-' + this._uid"
      v-model="toggleState">
      Armor Class
    </toggle-header>

    <div class="row" style="overflow: hidden;">
      <div class="col text-center">
        <under-text>
          <div slot="underline" class="ac">{{ $rulesets[ruleset].getArmorClass(ac) }}</div>
          AC
        </under-text>
      </div>
      <div class="col text-center">
        <under-text>
          <div slot="underline">10</div>
          Base
        </under-text>
      </div>
      <div class="col text-center">
        <under-text>
          <div slot="underline">{{ $rulesets[ruleset].getArmorClassDex(ac) }}</div>
          Dex
        </under-text>
      </div>
      <div class="col text-center">
        <under-input v-model.number="armorClass.armor.bonus" maxlength="2">
          Armor
        </under-input>
      </div>
      <div class="col text-center">
        <under-input v-model.number="armorClass.armor.maxDex" maxlength="2">
          Max Dex
        </under-input>
      </div>
    </div>

    <armor-details :toggleState="toggleState"></armor-details>

  </div>
</template>
<script>
import { mapState } from "vuex";
import ArmorDetails from "./details/_Pfrpg.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderText from "../shared/_UnderText.vue";
import ToggleHeader from "../shared/_ToggleHeader.vue";

export default {
  name: "character-defences-pfrpg",
  components: {
    ArmorDetails,
    UnderInput,
    UnderText,
    ToggleHeader
  },
  data() {
    return {
      toggleState: false
    };
  },
  computed: {
    ...mapState({
      ruleset: state => state.characters.current.ruleset,
      armorClass: state => state.characters.current.defense.armorClass,
      attributes: state => state.characters.current.attributes,
      size: state => state.characters.current.core.size
    }),
    dexterity() {
      return this.attributes.find(x => x.name === "dexterity");
    },
    ac() {
      let obj = {
        armorClass: this.armorClass,
        dexterity: this.dexterity,
        size: this.size
      };
      return obj;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.ac {
  color: $gray-700;
}
</style>
